export default __webpack_public_path__ + "static/media/low-risk-gauge-image.685b88af.png";